<template>
    <!--
        I didn't really want to make this a separate component, but it was the best way I could figure out to render
        both flights and flight stops as pins on the Origin Destination Travel Line. Leaving any extra markup laying around,
        even an empty div, screws up the "justify-content-evenly" of the parent container.
    -->
    <popper
        v-for="stop in flight.flightStops"
        :key="stop.id"

        placement="top"
        :content="$t('common.itinerary.mapPinPopper', {time: stop.groundTime, airportCode: stop.stopAirportCode})"
        :hover="true"
    >
        <div class="origin-destination-line-pin-container px-2">
            <font-awesome-icon :icon="['fal', 'map-pin']"  class="origin-destination-line-pin" />
        </div>
    </popper>
    <popper
        v-if="originDestination.arrivalAirportCode !== flight.arrivalAirportCode"
        placement="top"
        :content="$t('common.itinerary.mapPinPopper', {time: flight.layover, airportCode: flight.arrivalAirportCode})"
        :hover="true"
    >
        <div class="origin-destination-line-pin-container px-2">
            <font-awesome-icon :icon="['fal', 'map-pin']"  class="origin-destination-line-pin" />
        </div>
    </popper>
</template>

<script>
//External Components
import Popper from 'vue3-popper';

export default {
    name: 'OriginDestinationLinePin',
    components: {
        Popper
    },
    props: {
        flight: {
            type: Object,
            required: true
        },
        originDestination: {
            type: Object,
            required: true
        },
        trip: {
            type: Object,
            required: true
        },
    }
};
</script>

<style lang="scss" scoped>
.origin-destination-line-pin-container {
    line-height: 1.0; //This ensures the pin is snug against the trip line.
    cursor: pointer;

    .origin-destination-line-pin {
        color: $dark;
        -webkit-transition: color 0.25s ease-in-out 0s;
        transition: color 0.25s ease-in-out 0s;
        font-size: 1.75em;
    }

    &:hover .origin-destination-line-pin {
        color: $secondary;
    }
}
</style>